module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-3_BG-3f49c9a4dd66e40aec955f5691e6822b.svg";